import {
  GoalCompetencyFragmentFragment,
  GoalRoleFragmentFragment,
} from "types/graphql-schema";

import AppLink from "@components/link/link";

import GoalOwnerRoleCompetency from "./goal-owner-role-competency";

const GoalRoleGroup = ({
  role,
  goalOwnerId,
  competencies,
  goalId,
  goalCompetencyRoleItemIds,
}: {
  role: GoalRoleFragmentFragment;
  goalOwnerId: number;
  competencies: GoalCompetencyFragmentFragment[];
  goalId: number;
  goalCompetencyRoleItemIds: { competencyId: number; roleId: number }[];
}) => {
  if (competencies.length === 0 || !role) {
    return null;
  }
  return (
    <div key={role.id}>
      <div className="text-gray-500">
        <AppLink
          to={`/profile/${goalOwnerId}/career/?careerTrackId=${role.careerTrack.id}&roleId=${role.id}`}
          className="hover:underline"
        >
          {role.title} (Level: {role.level})
        </AppLink>
      </div>
      <div className="mt-3 flex gap-2">
        {competencies.map((competency) => (
          <GoalOwnerRoleCompetency
            key={competency.id}
            role={role}
            goalId={goalId}
            competency={competency}
            goalCompetencyRoleItemIds={goalCompetencyRoleItemIds}
          />
        ))}
      </div>
    </div>
  );
};

export default GoalRoleGroup;
